/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyResponseModel } from '../models/client-survey-response-model';
import { createSurveyResponse$Json } from '../fn/survey-response/create-survey-response-json';
import { CreateSurveyResponse$Json$Params } from '../fn/survey-response/create-survey-response-json';
import { createSurveyResponse$Plain } from '../fn/survey-response/create-survey-response-plain';
import { CreateSurveyResponse$Plain$Params } from '../fn/survey-response/create-survey-response-plain';
import { deleteSurveyResponseAsync$Json } from '../fn/survey-response/delete-survey-response-async-json';
import { DeleteSurveyResponseAsync$Json$Params } from '../fn/survey-response/delete-survey-response-async-json';
import { deleteSurveyResponseAsync$Plain } from '../fn/survey-response/delete-survey-response-async-plain';
import { DeleteSurveyResponseAsync$Plain$Params } from '../fn/survey-response/delete-survey-response-async-plain';
import { deleteSurveyResponsesAsync$Json } from '../fn/survey-response/delete-survey-responses-async-json';
import { DeleteSurveyResponsesAsync$Json$Params } from '../fn/survey-response/delete-survey-responses-async-json';
import { deleteSurveyResponsesAsync$Plain } from '../fn/survey-response/delete-survey-responses-async-plain';
import { DeleteSurveyResponsesAsync$Plain$Params } from '../fn/survey-response/delete-survey-responses-async-plain';
import { getSurveyResponse$Json } from '../fn/survey-response/get-survey-response-json';
import { GetSurveyResponse$Json$Params } from '../fn/survey-response/get-survey-response-json';
import { getSurveyResponse$Plain } from '../fn/survey-response/get-survey-response-plain';
import { GetSurveyResponse$Plain$Params } from '../fn/survey-response/get-survey-response-plain';
import { updateSurveyResponseAsync$Json } from '../fn/survey-response/update-survey-response-async-json';
import { UpdateSurveyResponseAsync$Json$Params } from '../fn/survey-response/update-survey-response-async-json';
import { updateSurveyResponseAsync$Plain } from '../fn/survey-response/update-survey-response-async-plain';
import { UpdateSurveyResponseAsync$Plain$Params } from '../fn/survey-response/update-survey-response-async-plain';

@Injectable({ providedIn: 'root' })
export class SurveyResponseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyResponse()` */
  static readonly GetSurveyResponsePath = '/api/SurveyResponse/{surveyResponseId}';

  /**
   * get surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyResponse$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyResponse$Plain$Response(params: GetSurveyResponse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return getSurveyResponse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyResponse$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyResponse$Plain(params: GetSurveyResponse$Plain$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.getSurveyResponse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /**
   * get surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyResponse$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyResponse$Json$Response(params: GetSurveyResponse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return getSurveyResponse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyResponse$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyResponse$Json(params: GetSurveyResponse$Json$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.getSurveyResponse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /** Path part for operation `updateSurveyResponseAsync()` */
  static readonly UpdateSurveyResponseAsyncPath = '/api/SurveyResponse/{surveyResponseId}';

  /**
   * update surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyResponseAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyResponseAsync$Plain$Response(params: UpdateSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return updateSurveyResponseAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyResponseAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyResponseAsync$Plain(params: UpdateSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.updateSurveyResponseAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /**
   * update surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyResponseAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyResponseAsync$Json$Response(params: UpdateSurveyResponseAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return updateSurveyResponseAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyResponseAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyResponseAsync$Json(params: UpdateSurveyResponseAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.updateSurveyResponseAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyResponseAsync()` */
  static readonly DeleteSurveyResponseAsyncPath = '/api/SurveyResponse/{surveyResponseId}';

  /**
   * delete surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyResponseAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyResponseAsync$Plain$Response(params: DeleteSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyResponseAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyResponseAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyResponseAsync$Plain(params: DeleteSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyResponseAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete surveyresponse by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyResponseAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyResponseAsync$Json$Response(params: DeleteSurveyResponseAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyResponseAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete surveyresponse by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyResponseAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyResponseAsync$Json(params: DeleteSurveyResponseAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyResponseAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `createSurveyResponse()` */
  static readonly CreateSurveyResponsePath = '/api/SurveyResponse';

  /**
   * create new surveyresponse.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyResponse$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyResponse$Plain$Response(params?: CreateSurveyResponse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return createSurveyResponse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyresponse.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyResponse$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyResponse$Plain(params?: CreateSurveyResponse$Plain$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.createSurveyResponse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /**
   * create new surveyresponse.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyResponse$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyResponse$Json$Response(params?: CreateSurveyResponse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
    return createSurveyResponse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyresponse.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyResponse$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyResponse$Json(params?: CreateSurveyResponse$Json$Params, context?: HttpContext): Observable<ClientSurveyResponseModel> {
    return this.createSurveyResponse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyResponseModel>): ClientSurveyResponseModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyResponsesAsync()` */
  static readonly DeleteSurveyResponsesAsyncPath = '/api/SurveyResponse';

  /**
   * delete multiple surveyresponse by version id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyResponsesAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSurveyResponsesAsync$Plain$Response(params: DeleteSurveyResponsesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyResponsesAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete multiple surveyresponse by version id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyResponsesAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSurveyResponsesAsync$Plain(params: DeleteSurveyResponsesAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyResponsesAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete multiple surveyresponse by version id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyResponsesAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSurveyResponsesAsync$Json$Response(params: DeleteSurveyResponsesAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyResponsesAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete multiple surveyresponse by version id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyResponsesAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSurveyResponsesAsync$Json(params: DeleteSurveyResponsesAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyResponsesAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
